import React from 'react';
import { Button } from '@mui/material';
import styled from 'styled-components';
import { ButtonLoader } from './Loader';

const SubmitButtonsContainer = styled.div`
  .cancel {
    margin-right: 8px;
  }
`;

interface ButtonsProps {
  hideTrueButton?: boolean;
  cancelButtonText?: string;
  submitButtonText?: string;
  onCancel: () => void;
  onSubmit?: () => void;
  onClick?: () => void;
  disabled?: boolean;
  isSubmitting?: boolean;
  className?: string;
  type?: 'submit' | 'button';
}

export const SubmitButtons: React.FC<ButtonsProps> = (props) => {
  const className = props.className || 'submit';
  return (
    <SubmitButtonsContainer>
      <Button variant="contained" onClick={props.onCancel} className="cancel">
        {props.cancelButtonText || 'キャンセル'}
      </Button>
      {!props.hideTrueButton && (
        <Button
          variant="contained"
          type={props.type || 'button'}
          className={className}
          color="primary"
          onClick={props.onSubmit || props.onClick}
          disabled={props.disabled}
        >
          {props.isSubmitting && <ButtonLoader size={16} />}
          {props.submitButtonText || '保存'}
        </Button>
      )}
    </SubmitButtonsContainer>
  );
};
